/**
* 我的资产-采购
* Created by zxf on 2021/04/16.
*/

<template>
  <div class="my-assets-procurement">
    <div class="main-content-area">
      <!-- @submit="onSubmit"-->
      <!-- -->
      <van-form ref="vanForm"
                v-if="typeQuery === 'edit' || typeQuery === 'create'">
        <div class="item-field"
             v-if="(workflowType !== 10 ||
                    ((workflowType === 20 && workflowType === 30) || assetsProcurementDate.itemList))"
             v-for="(item,index) in assetsProcurementDate" :key="item.id">
          <!--产品名称-->
          <van-field
              readonly
              clickable
              :value="item.assetObj.assetNameView"
              v-if="workflowType === 20"
              name="产品名称"
              label="产品名称"
              placeholder="请选择产品名称"
              required
              @click="item.assetNameSelectVisible = true"
              :rules="[{ required: true, message: '请选择产品名称' }]"
          />
          <!--选择产品-->
          <van-popup v-model="item.assetNameSelectVisible" position="bottom">
            <van-picker
                show-toolbar
                :columns="assetNameSelect"
                value-key="assetName"
                @confirm="(values) => assetConfirm(values,item)"
                @cancel="item.assetNameSelectVisible = false"
            />
          </van-popup>
          <!--资产数量（出库||入库）-->
          <van-field name="stepper"
                     v-if="workflowType === 20"
                     :label="`资产数量(${assetType})`">
            <template #input>
              <van-stepper v-model="item.assetNum"/>
            </template>
          </van-field>
          <!--资产采购价-->
          <van-field class="input-width"
                     label="资产采购价"
                     v-if="procurementPrice"
                     v-model="item.purchasePrice"
                     required
                     :rules="[{ required: true, message: '请填写资产采购价' }]"
                     placeholder="请填写资产采购价"
                     @keyup.native="priceLimit(item,'purchasePrice')"
                     maxlength="50" minlength="1">
          </van-field>
          <!--财务（收入金额||支出金额）-->
          <van-field class="inner-input"
                     v-if="workflowType === 30"
                     :label="financeDetail? '收入金额(元)' : '支出金额(元)'"
                     required
                     :rules="[{ required: true, message: `${financeDetail? '请填写收入金额': '请填写支出金额'}` }]"
                     :placeholder="financeDetail? '请填写收入金额': '请填写支出金额'"
                     type="text" size="mini"
                     @keyup.native="priceLimit(item,'amountChangeQuantity')"
                     v-model="item.amountChangeQuantity">
          </van-field>
          <!--子项字段（文本）-->
          <van-field :key="item.name+'_'+index"
                     required
                     :rules="[{ required: true, message: `${single.name}不能为空`}]"
                     v-model="item['file' + index]"
                     :placeholder="`请填写${single.name}`"
                     v-for="(single,index) in singleList"
                     :label="single.name">
          </van-field>
          <!--子项字段（日期）-->
          <van-cell-group :key="date.name+'_'+i"
                          v-for="(date,i) in dateNameList">
            <van-field
                readonly
                clickable
                required
                :rules="[{ required: true, message: `${date.name}不能为空`}]"
                name="datetimePicker"
                :value="item['oldDate' + i]"
                :label="date.name"
                placeholder="选择日期时间"
                @click="item['timeVisible' + i] = true"
            />
            <van-action-sheet v-model="item['timeVisible' + i]">
              <van-datetime-picker
                  :type="date.type"
                  v-model="item['date' + i]"
                  @confirm="updaterequiredTimeOfArrival(item,date.type,i)"
                  @cancel="item['timeVisible' + index] = false"
              />
            </van-action-sheet>
          </van-cell-group>

          <!--<div v-for="(date,i) in dateNameList" :key="date.id">

          </div>-->
          <div class="add-wrap">
            <div class="add-table-row" v-if="workflowType !== 10 && index === assetsProcurementDate.length-1">
              <van-button type="info"
                          native-type="button"
                          size="small" @click="addTableRow">
                新增一块
              </van-button>
            </div>
            <div class="del-item-field">
              <van-button type="danger" size="small"
                          native-type="button"
                          @click="deleteProcurement(item, index)">删除
              </van-button>
            </div>
          </div>
        </div>
        <AssetForm :typeQuery="typeQuery"
                   :singleList="singleList"
                   :workId="Number(workId)"
                   :dateNameList="dateNameList"
                   :workflowType="workflowType"
                   :procurementPrice="procurementPrice"
                   :valueDetailsList='valueDetailsList'
                   :assetsProcurementDate="assetsProcurementDate"
                   :addAssetDate="addAssetDate" ref="assetForm" v-if="childrenFlag"></AssetForm>
        <!-- @click.prevent="submitForm"
        提交触发  procurement.vue 里的 onSubmit（触发条件，表单验证通过 否则） 然后触发 create里的onSubmit进行表单提交-->
        <van-cell-group class="form-btn">
          <van-button type="info" native-type="button" @click="submitForm">{{(typeQuery === 'edit' && !journalFlag) ? '撤销并新增' : '提交'}}</van-button>
          <van-button @click.prevent="resetForm">取消</van-button>
        </van-cell-group>
      </van-form>
      <van-form ref="vanForm"
                v-if="typeQuery === 'view' || typeQuery === 'approval'">
        <div class="item-field"
             v-if="workflowType !== 10 || assetsProcurementDate.itemList"
             v-for="(item,index) in assetsProcurementDate" :key="item.id">
          <!--产品名称-->
          <van-field
              readonly
              :value="item.assetObj.assetNameView"
              v-if="workflowType === 20"
              name="产品名称"
              label="产品名称"
          />

          <!--资产数量（出库||入库）-->
          <van-field name="stepper"
                     readonly
                     :value="item.assetNum"
                     v-if="workflowType === 20"
                     :label="`资产数量(${assetType})`" />
          <!--资产采购价-->
          <van-field class="input-width"
                     readonly
                     label="资产采购价"
                     v-if="procurementPrice">
            <template #input>{{`${item.purchasePrice}元` | checkNull()}}</template>
          </van-field>
          <!--财务（收入金额||支出金额）-->
          <van-field class="inner-input"
                     readonly
                     v-if="workflowType === 30"
                     :label="financeDetail? '收入金额' : '支出金额'"
                     type="text" size="mini">
            <template #input>{{`${item.amountChangeQuantity}元` | checkNull()}}</template>
          </van-field>
          <!--子项字段（文本）-->
          <van-field :key="item.name+'_'+index"
                     readonly
                     v-model="item['file' + index]"
                     v-for="(single,index) in singleList"
                     :label="single.name">
          </van-field>
          <!--子项字段（日期）-->
          <van-cell-group :key="date.name+'_'+i"
                          v-for="(date,i) in dateNameList">
            <van-field
                readonly
                name="datetimePicker"
                :value="item['oldDate' + i]"
                :label="date.name" />
          </van-cell-group>
        </div>
        <AssetForm :typeQuery="typeQuery"
                   :singleList="singleList"
                   :workId="Number(workId)"
                   :journalFlag="journalFlag"
                   :dateNameList="dateNameList"
                   :workflowType="workflowType"
                   :procurementPrice="procurementPrice"
                   :valueDetailsList='valueDetailsList'
                   :assetsProcurementDate="assetsProcurementDate"
                   :addAssetDate="addAssetDate" v-if="childrenFlag"></AssetForm>
      </van-form>
    </div>
    <van-tabbar v-model="active" v-if="flag" safe-area-inset-bottom placeholder>
      <van-tabbar-item class="home-page" @click="checkStatus">
        <i slot="icon"
           slot-scope="props"
           class="iconfont office-automation-page">
          &#xe85e;
        </i>
        <span>查看</span>
      </van-tabbar-item>
      <van-tabbar-item class="home-page"
                       v-show="((user.id === applyUserId && status === '') || status === '10')
                              && (workflowStatus === 10 || workflowStatus === 20)"
                       @click="checkStatus">
        <i slot="icon"
           slot-scope="props"
           class="iconfont office-automation-page">
          &#xe641;
        </i>
        <span>编辑</span>
      </van-tabbar-item>
      <van-tabbar-item class="home-page"
                       v-show=" linkUrl !== 'working-journal' &&
                                Number(auditResult) === 20 &&
                                (Number(workflowStatus) === 20 ||
                                Number(workflowStatus) === 10)"
                       @click="checkStatus">
        <i slot="icon"
           slot-scope="props"
           class="iconfont office-automation-page">
          &#xe9e5;
        </i>
        <span>立即审批</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import { mapActions,mapState } from "vuex";

  export default {
    name: "my-assets-procurement",
    //根组件接收过来的方法，用来跳转当前页面（vue-router跳当前页面组件内部不会加载）
    inject: ['reload'],
    props: {
      workId: {
        type: Number,
        default: null
      },
      templateId: {
        type: Number,
        default: null
      },
      //新增 查看 编辑 重新 提交审批 类型
      typeQuery: {
        type: String,
        default: ''
      },
      //控制新增   还是   查看编辑重新提交审批
      flag: {
        type: Boolean,
        default: false
      },
      //状态(全部 '', 我申请的 '10', 我审批的 '20', 抄送给我的 '30')
      status:{
        type: String,
        default: ''
      }
    },
    data() {
      return {
        active: 0,
        singleList: [],
        dateNameList: [],
        //跳转链接
        linkUrl: '',
        //是否是日志工作流
        journalFlag: false,
        //表单默认数据
        defaultList: {},
        //工作流类型
        workflowType: '',
        //入库出库
        assetType: '',
        //采购价格
        procurementPrice: false,
        //财务收入huo支出
        financeDetail: false,
        //控制子组件是否加载
        childrenFlag: false,
        //模板数据
        templateDetailsData: [],
        //工作流详情
        valueDetailsList: null,
        //子项字段的数据
        assetsProcurementDate: [],
        addAssetDate: {
          //子项字段
          fieldChildrenList: [],
          //字段
          fieldList: [],
          auditConfigList: [],
          accessory: '',  //附件
          remarks: '',   //备注
          //审批人
          approver: [],
          //抄送人
          carbonCopyRecipients: []
        },
        assetNameSelect: [],
        //审批状态
        auditResult: '',
        //申请人id
        applyUserId: '',
        //工作流状态
        workflowStatus: '',
      }
    },
    computed:{
      ...mapState(['user'])
    },
    methods: {
      ...mapActions('officeAutomation', ['updateNavBarName']),
      //提交表单
      submitForm(){
        this.$refs.vanForm.validate()
          .then(() => {
            this.$refs.assetForm.handleFormInfo()
          })
          .catch((err) => {
            this.$toast.fail(err[0].message)
          })
      },
      //底部选项切换跳转
      checkStatus(){

        this.reload()
        let path = `/office-automation/${this.linkUrl}/procurement-view`

        if(this.linkUrl === 'my-assets'){
          path = '/office-automation/administrative/my-assets/procurement-view'
        }

        switch (this.active) {
          case 0:
            this.$router.replace({
              path: path,
              query: {
                type: 'view',
                id: this.workId,
                templateId: this.templateId,
                createId: this.createId,
                status: this.status
              }
            })
            break
          case 1:
            this.$router.replace({
              path: path,
              query: {
                type: 'edit',
                id: this.workId,
                templateId: this.templateId,
                createId: this.createId,
                status: this.status
              }
            })
            break
          case 2:
            this.$router.replace({
              path: path,
              query: {
                type: 'approval',
                id: this.workId,
                templateId: this.templateId,
                createId: this.createId,
                status: this.status
              }
            })
            break
        }
      },
      //资产选择确认
      assetConfirm(values, item) {
        item.assetObj.assetNameView = values.assetName
        item.assetObj.assetName = values.id
        item.assetNameSelectVisible = false
      },
      //价格格式限制
      priceLimit(item, name = '') {
        // item[name] = item[name].replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
        // item[name] = item[name].replace(/^\./g, ""); //验证第一个字符是数字
        // item[name] = item[name].replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
        // item[name] = item[name].replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        // item[name] = item[name].replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
        item[name] = this.decimalsLimit(item[name])
        let numArr = item[name].split('.')
        if (numArr[0].length > 8){
          let reg = /^[0-9]{1,8}$/
          if (!(reg.test(numArr[0]))){
            numArr[0] = numArr[0].slice(0,8)
          }
          item[name] = numArr.join('.')
        }
        if (item[name] == "" || item[name] < 0) {
          item[name] = "";
        }
        // if (item[name] > 99999999) {
        //   item[name] = 100000000;
        // }
      },
      errorHandler() {
        return true
      },
      deleteProcurement(row, i) {
        if (this.assetsProcurementDate.length <= 1) {
          this.$toast.fail('仅剩一块时不能删除')
        } else {
          this.assetsProcurementDate.splice(i, 1)
        }
      },
      //上传附件
      updateAccessory() {
        $('#uploadUpload').click()
      },
      //上传
      uploadUpload(e) {
        let file = e.target.files[0]
        if (!file) {
          return false
        }

        //文件大小验证
        let fileSize = this.validateFileSize(file, '10MB')
        if (!fileSize) {
          return false
        }

        //文件类型验证
        let fileType = this.validateFileType(file.name, '')
        if (!fileType) {
          return false
        }

        //加载中
        let loading = this.$loading({'target': 'body'})
        //对象存储上传文件
        let _this = this
        this.$uploadFile(file, (data) => {
          loading.close()
          if (data.code) {
            _this.$message.info(data.msg)
          } else {
            this.addAssetDate.accessory = data.fileUrl
          }
          //文件选择按钮重置
          e.target.value = "";
        })
      },
      //新增一行
      addTableRow() {
        //要克隆一下，不克隆数据会跟着变
        let obj = this.Unbind(this.defaultList)
        this.assetsProcurementDate.push(obj)
      },
      //改变要求送达时间的值
      updaterequiredTimeOfArrival(row, type, index) {
        if (row) {
          if (type === 'date') {
            row['oldDate' + index] = row['date' + index].getTime().toString().timeStampFormat('yyyy-MM-dd')
          } else {
            row['oldDate' + index] = row['date' + index].getTime().toString().timeStampFormat()
          }
        }
        row['timeVisible' + index] = false
      },
      //获取工作流详情
      getWorkDetailsData() {
        let obj = {
          id: this.workId
        }
        let loading = this.$loading({"target": "body"})
        this.$httpV3.post('oa/workflow/getDetail', obj)
          .then(res => {
            loading.close()
            if (Number(res.data.code) === 10000) {
              let data = res.data.data

              data = this.Unbind(data)
              if (data) {
                if (data.fieldList) {
                  data.fieldList.forEach(item => {
                    data.valueList.forEach(value => {
                      if (item.id === value.workflowFieldId) {
                        item.fieldValue = value.fieldValue
                      }
                    })
                    if (Number(item.fieldType) === 20) {
                      data.itemList.forEach(list => {
                        list.valueList.forEach(itemVal => {
                          if (item.id === itemVal.workflowFieldId) {
                            this.$set(itemVal, 'fieldCategory', item.fieldCategory)
                            this.$set(itemVal, 'fieldDesc', item.fieldDesc)
                          }
                        })
                      })
                    }
                  })
                }
                if (data.itemList) {
                  this.assetsProcurementDate = []
                  data.itemList.forEach(item => {
                    let obj = {
                      assetObj: {
                        assetName: item.asset ? item.asset.assetId : '',//资产名称
                        assetNameView: item.asset ? item.asset.assetName : '',
                      },
                      assetNum: item.asset ? item.asset.assetChangeQuantity : 0,  //资产数量
                      amountChangeQuantity: item.finance ? this.accDiv(item.finance.amountChangeQuantity, 100) : '', //收入或支出金额
                      purchasePrice: item.asset ? (item.asset.purchasePrice ? item.asset.purchasePrice : '') : null,  //资产采购价
                      assetNameSelectVisible: false,
                      inputVisible: false,
                      linkVisible: false,
                      priceVisible: false,
                      singList: [],
                      dateList: []
                    }
                    this.singleList.forEach((item, index) => {
                      let str = 'file' + index
                      obj[str] = ''
                      obj['singId' + index] = item.id
                      let singObj = {}
                      singObj['singId' + index] = item.id
                      obj.singList.push(singObj)
                    })
                    this.dateNameList.forEach((item, index) => {
                      let str = 'date' + index
                      obj[str] = ''
                      obj['oldDate' + index] = ''
                      obj['timeVisible' + index] = false
                      obj['dateId' + index] = item.id
                      let dateObj = {}
                      dateObj['dateId' + index] = item.id
                      obj.dateList.push(dateObj)
                    })
                    let fileArr = [], dateArr = []
                    item.valueList.forEach((value, index) => {
                      if (Number(value.fieldCategory) === 10) {
                        fileArr.push(value)
                      }
                      if (Number(value.fieldCategory) === 60) {
                        dateArr.push(value)
                      }
                    })
                    if (fileArr.length > 0) {
                      fileArr.forEach((item, index) => {
                        obj['file' + index] = item.fieldValue
                      })
                    }
                    if (dateArr.length > 0) {
                      dateArr.forEach((item, index) => {
                        if (item.fieldDesc === 'date') {
                          obj['oldDate' + index] = item.fieldValue.toString().timeStampFormat('yyyy-MM-dd')
                        } else {
                          obj['oldDate' + index] = item.fieldValue.toString().timeStampFormat()
                        }
                        obj['timeVisible' + index] = false

                      })
                    }
                    this.assetsProcurementDate.push(obj)
                  })
                }
                if(data.auditUserList){
                  data.auditUserList.forEach(item => {
                    if(item.auditUserId === this.user.id){
                      this.auditResult = item.auditResult
                    }
                  })
                }
                this.workflowStatus = data.workflowStatus
                this.applyUserId = data.applyUserId
                this.valueDetailsList = data
              }
              this.childrenFlag = true
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(rej => {
            loading.close()
          })
      },
      //获取模板详情
      getTemplateDetailsData() {
        let obj = {
          id: this.templateId
        }
        let loading = this.$loading({"target": "body"})
        this.$httpV3.post('oa/workflowTemplate/getDetail', obj)
          .then(async res => {
            loading.close()
            if (Number(res.data.code) === 10000) {
              let data = res.data.data
              if (data) {
                switch (Number(data.workflowTemplateCategory)) {
                  case -1:
                    this.linkUrl = 'currency'
                    break
                  case 10:
                    this.linkUrl = 'working-journal'
                    this.journalFlag = true
                    break
                  case 20:
                    this.linkUrl = 'my-assets'
                    break
                  case 30:
                    this.linkUrl = 'financing'
                    break
                }
                this.workflowType = data.workflowTemplateCategory
                /*修改navBar的名字*/
                this.updateNavBarName(data.workflowTemplateName)
                if (data.categoryConfigList) {
                  data.categoryConfigList.forEach(item => {
                    switch (Number(item.paramType)) {
                      case 10010:
                        if (Number(item.paramValue) === 10) {
                          this.financeDetail = true
                        } else {
                          this.financeDetail = false
                        }
                        break;
                      case 20010:
                        if (Number(item.paramValue) === 10) {
                          this.assetType = '入库'
                        } else if (Number(item.paramValue) === 20) {
                          this.assetType = '出库'
                        }
                        break;
                      case 20020:
                        if (Number(item.paramValue) === 1) {
                          this.procurementPrice = true
                        } else {
                          this.procurementPrice = false
                        }
                        break;
                    }
                  })
                }

                data.fieldList.forEach((item, index) => {
                  if (Number(item.fieldType) === 10) {
                    this.addAssetDate.fieldList.push(item)
                  }
                  if (Number(item.fieldType) === 20) {
                    switch (Number(item.fieldCategory)) {
                      case 10:
                        let singleObj = {
                          name: item.fieldName,
                          value: '',
                          id: item.id
                        }
                        this.singleList.push(singleObj)
                        break;
                      case 60:
                        let dateObj = {
                          name: item.fieldName,
                          value: '',
                          type: item.fieldDesc,
                          timeVisible: false,
                          id: item.id
                        }
                        this.dateNameList.push(dateObj)
                        break;
                    }
                  }
                })
                let obj = {
                  assetObj: {
                    assetName: '',//资产名称
                    assetNameView: '',
                  },
                  assetName: '',//资产名称
                  assetNum: 0,  //资产数量
                  oldAssetNum: 0,
                  amountChangeQuantity: '', //收入或支出金额
                  purchasePrice: '',  //资产采购价
                  assetNameSelectVisible: false,
                  inputVisible: false,
                  linkVisible: false,
                  priceVisible: false,
                  singList: [],
                  dateList: []
                }
                this.singleList.forEach((item, index) => {
                  let str = 'file' + index
                  obj[str] = ''
                  obj['singId' + index] = item.id
                  let singObj = {}
                  singObj['singId' + index] = item.id
                  obj.singList.push(singObj)
                })
                this.dateNameList.forEach((item, index) => {
                  let str = 'date' + index
                  obj[str] = ''
                  obj['oldDate' + index] = ''
                  obj['timeVisible' + index] = false
                  obj['dateId' + index] = item.id
                  let dateObj = {}
                  dateObj['dateId' + index] = item.id
                  obj.dateList.push(dateObj)
                })
                this.defaultList = this.Unbind(obj)
                this.assetsProcurementDate = [obj]
                this.addAssetDate.auditConfigList = data.auditConfigList
                this.addAssetDate.myAuditConfig = data.myAuditConfig
              }

              this.templateDetailsData = data
              if (this.workId) {
                await this.getWorkDetailsData()
              } else {
                this.childrenFlag = true
              }
            }
          })
          .catch(rej => {
            loading.close()
          })
      },
      //获取资产数据
      getAssetData() {
        this.$httpV3.post('oa/asset/listSelect')
          .then(res => {
            if (Number(res.data.code) === 10000) {
              let data = res.data.data
              if (data) {
                /*let arr = []
               /!* data.forEach((item,index) => {
                  let obj = {
                    values: item.assetName,
                    defaultIndex: index,
                    id: item.id
                  }
                  arr.push(obj)
                })*!/*/
                this.assetNameSelect = data
              }
            }
          })
      },
      //重置表单
      resetForm() {
        this.$refs.assetForm.resetForm()
      },

      /*async getWorkflowTemplateListInfo() {
        let obj = {
          id: null
        }
        await this.$httpV3.post('oa/workflowTemplate/listSelect', obj)
          .then(res => {
            if (Number(res.data.code) === 10000) {
              let data = res.data.data
              this.getWorkflowTemplateList(data)
            }
          })
      },*/
    },
    async created() {
      if (this.templateId) {
        await this.getTemplateDetailsData()
      }
      /* await this.getWorkflowTemplateListInfo()*/
      this.getAssetData()
      switch (this.typeQuery) {
        case 'view':
          this.active = 0
          break
        case 'edit':
          this.active = 1
          break
        case 'approval':
          this.active = 2
          break
      }
    }
  }
</script>

<style lang="stylus" type="text/stylus">
  .my-assets-procurement {
    background #f4f4f4
    .van-cell{
      padding 0.1rem 0.16rem
      font-size 0.14rem
      line-height 0.24rem
      &.van-cell--required{
        &:before{
          left 0.08rem
          font-size 0.14rem
        }
      }
      .van-field__body{
        .van-field__control{
          min-height 0.24rem
          flex-wrap wrap
          /*上传*/
          .van-uploader{
            .van-uploader__wrapper{
              .van-uploader__upload{
                width 0.8rem
                height 0.8rem
                margin 0 0.08rem 0.08rem 0
                .van-icon{
                  font-size 0.24rem
                }
              }
              .van-uploader__input-wrapper{
                .van-button{
                  height 0.32rem
                  padding 0 0.08rem
                  border-radius 0.02rem
                  .van-button__content{
                    .van-icon{
                      font-size 0.14rem
                    }
                    .van-button__text{
                      margin-left 0.04rem
                      font-size 0.12rem
                    }
                  }
                }
                .van-tag{
                  font-size 0.12rem
                  line-height 0.16rem
                  border-radius 0.02rem
                }
              }
            }
          }
          /*复选框 单选框*/
          .van-checkbox-group{
            .van-checkbox{
              margin-right 0.12rem
              .van-checkbox__icon{
                font-size 0.18rem
              }
              .van-checkbox__label{
                margin-left 0.08rem
                line-height 0.2rem
              }
            }
          }
          .van-radio-group{
            .van-radio{
              margin-right 0.12rem
              .van-radio__icon{
                font-size 0.18rem
              }
            }
          }
          /*步进器*/
          .van-stepper{
            .van-stepper__input{
              width 0.32rem
              height 0.28rem
              margin 0 0.02rem
              font-size 0.14rem
              border-width 0.01rem 0
            }
            .van-stepper__minus{
              border-radius 0.04rem 0 0 0.04rem
              width 0.28rem
              height 0.28rem
            }
            .van-stepper__plus{
              border-radius  0 0.04rem 0.04rem 0
              width 0.28rem
              height 0.28rem
            }
          }
          /*tag*/
          .van-tag--medium{
            padding 0.02rem 0.06rem
            font-size 0.12rem
            line-height 0.16rem
            border-radius 0.02rem
            .el-link{
              font-size 0.14rem
              .el-link--inner{
                max-width 1.6rem
                overflow hidden
                white-space nowrap
                text-overflow:ellipsis;
              }
            }
          }
          .accessory-tag{
            margin 0 0 0.05rem 0.05rem
            &.el-tag{
              height 0.32rem
              padding 0 0.1rem
              line-height 0.3rem
              font-size 0.12rem
              border-width 0.01rem
              border-radius 0.04rem
            }
          }
        }
      }
      .van-field__error-message{
        font-size 0.12rem
      }
    }
    .main-content-area {
      padding 0.1rem 0
      .module-header {
        margin-bottom 0.1rem
        .module-header-title {
          .title {
            font-size 18px
            color rgb(57, 96, 244)
            font-weight bold
          }
        }
      }

      .item-field {
        background #fff
        margin-bottom 0.1rem
        .add-wrap{
          display flex
          justify-content flex-end
          .del-item-field {
            text-align right
            padding 0.1rem
            .van-button{
              height 0.32rem
              padding 0 0.08rem
              font-size 0.12rem
              border-width 0.01rem
              border-radius 0.02rem
            }
          }
        }

        .van-popup{
          .van-picker{
            .van-picker__toolbar{
              height 0.44rem
              .van-picker__cancel{
                padding 0 0.16rem
                font-size 0.14rem
              }
              .van-picker__confirm{
                padding 0 0.16rem
                font-size 0.14rem
              }
            }
            .van-picker__columns{
              height 2.64rem
              .van-picker-column{
                font-size 0.16rem
                .van-picker-column__item{
                  padding 0 0.04rem
                  margin 0 0.1rem
                  font-size 0.16rem
                }
              }
            }
          }
        }
      }
      .form-btn {
        padding 0.1rem 0
        margin-top 0.2rem
        text-align center
        .van-button {
          padding 0 0.15rem
          font-size 0.14rem
          height 0.32rem
          border-radius 0.02rem
          margin-right 0.1rem
        }
      }
      .add-table-row {
        text-align right
        margin 0 0.1rem 0.1rem 0
        .van-button {
          margin-top 0.1rem
          height 0.32rem
          padding 0 0.08rem
          font-size 0.12rem
          border-radius 0.02rem
        }
      }

      .form-wrap {
        .el-form-item__content {
          display flex
          flex-wrap wrap
          align-items center

          .avatar-wrap {
            margin 0 10px

            .userName {
              text-align center
            }
          }

          .add-carbon-copy-recipients {
            margin-left 20px

            .iconfont {
              font-size 40px
              color #999
              cursor pointer
            }
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/office-automation/administrative/procurement.vue